import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { MarkNotificationsReadInput, Notification } from '@wrapforce/shared';
import { api } from '@/lib/api';

export function useNotifications() {
  return useQuery({
    queryKey: ['notifications'],
    queryFn: () => api.get<{ items: Notification[]; nextCursor: string | null }>('/api/v1/me/notifications'),
    staleTime: 15_000,
    refetchInterval: 5 * 60_000,
    refetchIntervalInBackground: false,
  });
}

export function useMarkNotificationsRead() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: MarkNotificationsReadInput) => api.post('/api/v1/me/notifications/read', input),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['notifications'] }),
  });
}
